import { Navigate } from "react-router-dom";
import { AUTH_STATUS } from "../utils/authUtils";
import User from "../types/user";
import useAuth from "../context/AuthContext";

interface WithAuthProps {
  user?: User;
}

export default function withAuth<T extends Partial<WithAuthProps>>(Component: React.FC<T & WithAuthProps>) {
  return function WithAuth(props: Omit<T, keyof WithAuthProps>) {
    const {user, status} = useAuth();

    if (status === AUTH_STATUS.LOADING) {
      return (
        <div className="center">
          <div className="loader"></div>
        </div>
      );
    }

    if (status === AUTH_STATUS.UNAUTHENTICATED) {
      return <Navigate to="/login" />;
    }

    if (status === AUTH_STATUS.AUTHENTICATED) {
      return <Component {...props as T} user={user} />;
    }

    return null;
  };
}


